import React, {useEffect, useMemo, useState} from 'react';
import useQuestionStore from '../store/navigation';
import {SingleOption} from '../types/question';
import QuestionMultiSelectorContainer from './SelectorContainer';
import {useResultStore} from '../store/responses';
import {sendAnalyticPayload} from '../utils/analytic';
import {QuestionData, QuestionStepName} from '../constants/questions';

interface Props {
  title: string;
  singleSelectOptions: SingleOption[];
  subHeading?: string;
}

const QuestionSingleSelector: React.FC<Props> = ({
  title,
  singleSelectOptions,
  subHeading,
}) => {
  const {setCurrentQuestion, currentQuestion} = useQuestionStore();
  const {updateQuestion, result} = useResultStore();
  const [selectedOptions, setSelectedOptions] = useState<SingleOption[]>(
    singleSelectOptions.map((option) => ({
      ...option,
      isSelect: false,
    })),
  );

  useEffect(() => {
    if (singleSelectOptions && singleSelectOptions?.length > 0) {
      setSelectedOptions(
        singleSelectOptions.map((option) => ({
          ...option,
          isSelect: option.value === result[currentQuestion],
        })),
      );
    } else setSelectedOptions([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleSelectOptions, result[currentQuestion]]);

  const handleOptionChange = (optionSelected: SingleOption) => {
    updateQuestion({
      id: currentQuestion,
      value: optionSelected.value,
    });
    setCurrentQuestion(optionSelected.nextStepId);

    const questionName = QuestionStepName[currentQuestion] || currentQuestion;
    sendAnalyticPayload({
      process: {
        StepName: questionName,
        StepNumber:
          QuestionData[currentQuestion]?.progressValue.toString() || '',
      },
      question: [
        {
          Question: questionName,
          Answer: [
            {
              value: optionSelected.label,
              type: 'single_select',
            },
          ],
        },
      ],
    });
  };
  const handleSubmitNext = () => {
    const selectedCount = selectedOptions.filter(
      (option) => option.isSelect,
    ).length;

    if (selectedCount !== 1) return;
    const result = selectedOptions.find((option) => option.isSelect);

    if (!result) return;
    updateQuestion({
      id: currentQuestion,
      value: result.value,
    });
    const questionName = QuestionStepName[currentQuestion] || currentQuestion;
    sendAnalyticPayload({
      process: {
        StepName: questionName,
        StepNumber:
          QuestionData[currentQuestion]?.progressValue.toString() || '',
      },
      question: [
        {
          Question: questionName,
          Answer: [
            {
              value: result.value,
              type: 'single_select',
            },
          ],
        },
      ],
    });
    console.debug(result);
    setCurrentQuestion(result.nextStepId);
  };

  const isDisabledButton = useMemo(() => {
    const selectedCount = selectedOptions.filter(
      (option) => option.isSelect,
    ).length;
    return selectedCount !== 1;
  }, [selectedOptions]);
  return (
    <QuestionMultiSelectorContainer
      title={title || ''}
      selectedOptions={selectedOptions}
      isDisabledButton={isDisabledButton}
      handleOptionChange={handleOptionChange}
      handleSubmitNext={handleSubmitNext}
      subHeading={subHeading}
    />
  );
};

export default QuestionSingleSelector;
